import { AlertTriangle, RefreshCw } from "lucide-react";

export const MARKETPLACES = ["Amazon", "Flipkart", "Meesho", "Myntra", "Snapdeal", "Shopify", "WooCommerce"];
export const COLORS = { Amazon: "#2563eb", Flipkart: "#f59e0b", Meesho: "#ef4444", Myntra: "#db2777", Snapdeal: "#0891b2", Shopify: "#10b981", WooCommerce: "#8b5cf6" };
export const slug = (s) => String(s).toLowerCase().replaceAll(" ", "-");

export const Money = ({ value }) => <span>₹{Number(value).toLocaleString("en-IN")}</span>;
export const Channel = ({ name }) => <span className="marketplace-dot"><i style={{ background: COLORS[name] }} />{name}</span>;
export const Status = ({ children }) => <span className={`status status-${slug(children)}`}>{children}</span>;

export function DataTable({ columns, rows, rowKey, testId }) {
  return <div data-testid={testId} className="data-table" style={{ "--cols": columns.map((c) => c.w || "1fr").join(" ") }}>
    <div className="table-row table-head">{columns.map((c) => <span key={c.label}>{c.label}</span>)}</div>
    {rows.map((row) => <div className="table-row" key={row[rowKey]} data-testid={`${testId}-row-${row[rowKey]}`}>
      {columns.map((c) => <div className="cell" data-label={c.label} key={c.label}>{c.render(row)}</div>)}
    </div>)}
    {rows.length === 0 && <div data-testid={`${testId}-empty`} className="table-empty">No records found</div>}
  </div>;
}

export function ErrorBox({ message, onRetry, t }) {
  return <div data-testid="api-error-box" className="error-box" role="alert">
    <span className="error-icon"><AlertTriangle size={20} /></span>
    <div><strong>{t("Couldn’t load your dashboard data", "डैशबोर्ड डेटा लोड नहीं हो सका")}</strong><p data-testid="api-error-message">{message}</p></div>
    <button data-testid="api-error-retry-button" className="dark-button" onClick={onRetry}><RefreshCw size={15} />{t("Retry", "फिर से कोशिश करें")}</button>
  </div>;
}

export const Heading = ({ title, sub, children }) => <div className="panel-heading"><div><h2>{title}</h2><p>{sub}</p></div>{children}</div>;
